/**
 * Company Loader
 * 
 * Loads companies while scrolling.
 * Companies can also be searched, this prevents the scrolling loader.
 * The scroll loader, and the search function both make use of the type of company filter
 */

export default class CompanyLoader {
  constructor() {
    this.postsPerLoad = 12;
    this.noResultsMsg = '<div class="col">Er zijn geen resultaten gevonden</div>';

    this.loadedPosts = [];
    this.inputBarrier = 0;
    this.busyLoading = false;
    this.companyContainer = $('.companies');
    this.mainBranch = $('#main-company-type').val();
    this.branchFilter = $('.companies-wrap #company-type');
    this.search = $('.companies-wrap #company-search');
    this.routes = {
      getCompanies: `${companyLoaderOptions.restURL}winkelpark/v1/get-companies`,
      searchCompanies: `${companyLoaderOptions.restURL}winkelpark/v1/search-companies`,
    };
    this.cacheBuster = companyLoaderOptions.cacheBuster || String(Date.now());
  }

  init() {
    if (!this.companyContainer.length) {
      return;
    }

    this.retrieveCompanies();

    $(window).on('scroll', () => {
      // Prevent this handler when content is being loaded
      if (this.busyLoading) {
        return;
      }

      const { companyContainer } = this;
      const containerHeight = companyContainer.height();
      const containerOffsetY = companyContainer.offset().top;
      const windowHeight = $(window).height();
      const visibleMargin = 150;
      
      /* eslint-disable max-len */
      const offsetClauses = [
        $(window).scrollTop() >= (containerHeight + containerOffsetY) - (windowHeight - visibleMargin),
        $(window).scrollTop() === ($(document).height() - windowHeight),
      ];
      /* eslint-enable max-len */

      // Load more when scrolled past container, or end of page is reached
      if ($.inArray(true, offsetClauses) !== -1) {
        this.retrieveCompanies();
      }
    });

    /**
     * Search event
     */
    let searchTimeout = null;
    this.search.on('keyup', () => {
      clearTimeout(searchTimeout);

      searchTimeout = setTimeout(() => {
        this.clearResults();
        if (this.search.val().length > this.inputBarrier) {
          this.searchCompanies(this.search.val());
        } else {
          this.retrieveCompanies();
        }
      }, 500);
    });

    /**
     * Filter change event
     */
    this.branchFilter.on('change', () => {
      this.clearResults();

      if (this.search.val().length > this.inputBarrier) {
        this.searchCompanies(this.search.val());
      } else {
        this.retrieveCompanies();
      }
    });
  }

  retrieveCompanies() {
    const self = this;
    const branchId = this.branchFilter.val();

    // Don't retrieve companies when the search input has a value
    if (this.search.val().length > this.inputBarrier) {
      return;
    }

    this.companyContainer.addClass('loading');
    this.busyLoading = true;

    $.ajax({
      type: 'GET',
      url: self.routes.getCompanies,
      data: {
        exclude: self.loadedPosts,
        amount: self.postsPerLoad,
        branch: branchId,
        mainBranch: this.mainBranch,
        cacheBuster: this.cacheBuster,
      },
      success: (response) => {
        if (self.companyContainer.children().length && self.loadedPosts.length === 0) {
          if (!response.content.length) {
            response.content = self.noResultsMsg;
          }

          self.companyContainer
            .html(response.content)
            .removeClass('loading');
        } else {
          self.companyContainer
            .append(response.content)
            .removeClass('loading');
        }
        
        // Set a list of posts that are already loaded
        self.loadedPosts = [...self.loadedPosts, ...response.retrieved_ids];
      },
      error: (xhr, status, error) => {
        console.error(xhr, status, error);
      },
      complete: () => {
        this.busyLoading = false;
      },
    });
  }

  searchCompanies(search) {
    const self = this;
    const branchId = this.branchFilter.val();

    this.companyContainer.addClass('loading');
    this.busyLoading = true;

    $.ajax({
      type: 'GET',
      url: self.routes.searchCompanies,
      data: {
        title: search,
        branch: branchId,
        random: false,
        mainBranch: this.mainBranch,
        cacheBuster: this.cacheBuster,
      },
      success: (response) => {
        if (!response.content.length) {
          response.content = this.noResultsMsg;
        }

        self.companyContainer
          .html(response.content)
          .removeClass('loading');
      },
      error: (xhr, status, error) => {
        console.error(xhr, status, error);
      },
      complete: () => {
        this.busyLoading = false;
      },
    });
  }

  clearResults() {
    this.loadedPosts = [];
    this.companyContainer.html('');
  }
}
